import { createSelector } from '@app/utils/createSelector'

import { createReduxSlice } from '@app/store/redux_slice'

/** Total unread messages across all chats. Read by the nav badge and the page title. */
const unreadCountSlice = createReduxSlice<number>('unreadCount')

export const unreadCountSelector = createSelector([unreadCountSlice.selector], state => state ?? 0)

export const setUnreadCountSlice = (count: number) => unreadCountSlice.set(count)
